// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"67dfb3ed","605":"18396e95","725":"35f400eb"}[chunkId] + ".chunk.js";
};